import { Box, Button, CircularProgress, Container, Stack, Typography } from "@mui/material"
import { createFaqs, retrieveFaqs, updateFaqs } from "../../../redux/admin-slices/faqs.slice"
import { toastError } from "../../../redux/guest-slices/other.slice"
import { NavLink, useNavigate, useParams } from "react-router-dom"
import InputFieldA from "../../../components/ui/InputFieldA"
import { useDispatch, useSelector } from "react-redux"
import Icons from "../../../assets/js/Icons"
import { useEffect, useState } from "react"

function AddFaqs() {
  const { faqId } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [faq, setFaq] = useState({})
  const { loadings } = useSelector(state => state.otherSlice)

  // Handle create FAQs
  const handleSubmit = (e) => {
    e.preventDefault()
    const form = e.target
    const formData = Object.fromEntries(new FormData(e.target))
    if ([
      formData?.question,
      formData?.answer,
    ]?.some((value) => value?.trim() === "" || !value)
    ) {
      return dispatch(toastError("Please fill all required field!"))
    }

    if (faqId) {
      dispatch(updateFaqs({ faqId, formData })
      ).unwrap().then(() => {
        form.reset()
        navigate("/faqs/all")
      }).catch(() => { })
    } else {
      dispatch(createFaqs(formData)
      ).unwrap().then(() => {
        form.reset()
        navigate("/faqs/all")
      }).catch(() => { })
    }
  }

  // Handle get single FAQ
  const handleGet = () => {
    dispatch(retrieveFaqs(faqId)
    ).unwrap().then((data) => {
      setFaq(data)
    }).catch(() => { })
  }

  useEffect(() => {
    if (faqId) { handleGet() }

    // eslint-disable-next-line
  }, [])

  return (
    <Container maxWidth={false} fixed sx={{ py: 5 }}>
      <Box sx={{ mb: 5 }}>
        <Box className="overview-container">
          <Typography variant="pageTitle">Add FAQs</Typography>
          <Button
            to="/faqs/all"
            variant="outlined"
            LinkComponent={NavLink}
            startIcon={<Icons.ListSolid />}
          >View All FAQs
          </Button>
        </Box>
      </Box>

      <Box className="page-content">
        <Stack spacing={3} component="form" onSubmit={handleSubmit}>
          <Box>
            <InputFieldA
              type="text"
              name="question"
              label="Question"
              value={faq?.question || ""}
              placeholder="Enter Question"
            />
          </Box>
          <Box>
            <InputFieldA
              name="answer"
              label="Answer"
              type="textarea"
              value={faq?.answer || ""}
              placeholder="Enter Answer"
            />
          </Box>
          <Box textAlign="end">
            <Button
              type="submit"
              variant="contained"
              sx={{ minWidth: "150px" }}
              endIcon={
                loadings?.create &&
                <CircularProgress size={22} color="text" thickness={6} />
              }
            >Submit
            </Button>
          </Box>
        </Stack>
      </Box>
    </Container>
  )
}

export default AddFaqs